import { BulkResizeImage } from "../types";

export const getImportedImages = (images: BulkResizeImage[]) => images.filter((image) => image.state === "imported" && !image.isCorrupted);
